<div *ngIf="beneficios.length > 0">
  <h1 class="title" style="margin: 25px 0">Beneficios de AlmaMedis</h1>

  <div class="row">
  <div class="col-12 col-md-6 col-lg-4 mb-4" *ngFor="let item of beneficios">
    <div class="examedi-card h-100">
      <div class="examedi-card__body d-flex flex-column h-100">
        
        <div class="mb-3 text-center">
          <img [src]="item.logo" [alt]="item.nombre" class="examedi-card__logo" />
        </div>

  <h6 class="examedi-card__title mb-3">
    {{ item.titulo }}
  </h6>

  <p class="examedi-card__text mb-5">
    {{ item.descripcion }}
  </p>

        <div class="mt-auto">
          <button
            *ngIf="item.tipo === 'examedi'"
            type="button"
            class="examedi-card__action"
            (click)="openExamedi()">
            <span>
              <i class="fi fi-rr-angle-small-right d-flex align-items-center justify-content-center"></i>
            </span>
          </button>

          <button
            *ngIf="item.tipo === 'medidor'"
            type="button"
            class="examedi-card__action"
            (click)="openModal()">
            <span>
              <i class="fi fi-rr-angle-small-right d-flex align-items-center justify-content-center"></i>
            </span>
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
</div>

<div class="modal fade show d-block" *ngIf="isModalOpen" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog2 modal-dialog-centered modal-lg" role="document">
    <div class="modal-content custom-modal card">
      <div class="card-header d-flex justify-content-end align-items-center p-0">
        <button type="button" class="btn-close-card" aria-label="Close" (click)="closeModal()">
          <mat-icon class="close-icon">close</mat-icon>
        </button>
      </div>

      <div class="card-body modal-scroll">
        <div class="inner-frame">
          <app-medidor-signos *ngIf="isModalOpen" (requestClose)="closeModal()"></app-medidor-signos>
        </div>
      </div>
    </div>
  </div>
</div>